import React from "react";
import "./About.css";
import VanillaTilt from "vanilla-tilt";
import pp from "../../assests/Arjun.jpg";
import { useEffect } from "react";
import CountUp from "react-countup";

export default function About() {
  useEffect(() => {
    VanillaTilt.init(document.querySelector(".box"), {
      max: 25,
      speed: 400,
    });
  }, []);
  return (
    <div id="about">
      <div className="about">
        <div className="title-about">
          <h3 className="text1-about animate__animated animate__fadeInUp wow">
            About <span>me</span>{" "}
          </h3>
        </div>
        <div className="about-content">
          <div className="photo">
            <div className="box">
              <img src={pp} alt="" />
            </div>
          </div>
          <div className="main-contain">
            <h3 className="text3-about mt2 animate__animated animate__fadeInUp wow">
              I'm <span>Arjun chauhan</span>
            </h3>
            <p className="para">
              I completed my schooling from CBSE board throughout first
              division. Currently pursuing my graduation in B.tech CSE from
              Graphic Era Hill University,Dehradun,Uttarakhand (GEHU) 2021-2025.<br /><br />
              <li id="newli">A coder who turns coffee into code and an open source
              contributor. Over 4.2years of experience,which
              includes 4years of experience in Full Stack 
              Development,3.5years of experience in ReactJs and 2years of experience
              in UI Designing.</li> <br />
              <li id="newli">Expertise in analyzing the DocumentObjectModel
              (DOM)Layout,DOMFunctions,andJ avascript
              functions,CascadingStyles across-browser using Firebug,
              Developer ToolBar.</li><br />
              <li id="newli">Good Experience in React.JS for creating interactive UI using One-way
              data flow, Virtual DOM, JSX concepts.</li><br />
              <li id="newli">Experience in Node environment using Node.js,NPM
              and express.js. Also in RESTful to integrate between
              Application to Application Experience with front-end development with
              back-end system integration.</li><br />
             <li id="newli">Experience in Version Control tools like GIT management.</li>
            </p>
            <a
              href="Resume/Arjun Chauhan.pdf"
              className="btn1-about animate__animated animate__fadeInUp wow"
            >
              <span>Download CV</span>
              <i></i>
            </a>
          </div>
        </div>
      </div>
      <div className="onViewPort">
        <div className="stats">
          <div>
            <CountUp
              className="wow animate__animated animate__fadeInUp wow sta"
              end={4}
              suffix="+"
            />
            <h3 className="animate__animated animate__fadeInUp wow">
              Years Experience as FSD
            </h3>
          </div>
          <div>
            <CountUp
              className=" animate__animated animate__fadeInUp wow wow sta"
              end={20}
              suffix="+"
            />
            <h3 className="animate__animated animate__fadeInUp wow">
              Projects
            </h3>
          </div>
          <div>
            <CountUp
              className=" animate__animated animate__fadeInUp wow wow sta"
              end={25}
              suffix="+"
            />
            <h3 className="animate__animated animate__fadeInUp wow">
              Happy Clients
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
}
